<template>
  <div id="tab-commonHawb" class="app-main-inner">
    <div class="form-card-wrapper">
      <div class="form-card section" style="width: 100%;padding-bottom: 10px;">
        <el-form label-width="90px" label-position="left" style="height:100%;width: 1000px;">
          <div style="display: flex;justify-content: space-between">
            <el-form-item label="MAWB No." class="custom">
              <div style="display: flex;align-content: center;align-items: center">
                <el-input v-model="job.mbl" no="mbl" style="width: 206px;" :disabled="true" />
                <el-tooltip :content="$t('queryJob.BillOfLadingInformationTracking')" placement="right">
                  <img :src="img.follow" style="width: 20px;height: 20px;display: list-item;cursor: pointer" :tip="$t('queryJob.BillOfLadingInformationTracking')" @click="showMBLDetailBtnClickHandler">
                </el-tooltip>

              </div>
            </el-form-item>
            <el-form-item label="HAWB No." class="custom">
              <cargo-input
                v-model="form.hblNbr2"
                :disabled="!isEditing"
                no="hblNbr2"
                :auto-uppercase="isUppercase"
                style="width: 206px;"
              />
            </el-form-item>
            <div style="display: flex; flex-wrap: nowrap; min-width: 0; align-items: center;margin-left: -24px;margin-top: -6px;">
              <span
                id="toInsure"
                v-permission="['button_insurance_toInsure']"
                type="primary"
                :class="!isEditing?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
                style="min-width:50px!important;margin-left:15px;white-space: nowrap;flex-shrink: 0;"
                @click="()=>{if (!isEditing){pm.toInsure()}}"
              >{{ $t('SeaExport.Insure') }}
              </span>
              <el-button
                no="AntiTerroristFormattedAddress"
                :disabled="!isEditing"
                type="primary"
                style="white-space: nowrap;flex-shrink: 0;"
                @click="showAddressFormatDialog"
              >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
              <el-button no="CopyFromOtherBill" :disabled="!isEditing" type="primary" style="white-space: nowrap;flex-shrink: 0;" @click="copyFromOtherBillHandler"> {{ $t('SeaExport.CopyFromOtherBill') }} </el-button>
              <el-button no="CodeSearching" :disabled="!isEditing" type="primary" style="white-space: nowrap;flex-shrink: 0;" @click="popUpAddressWindow"> {{ $t('SeaExport.CodeSearching') }} </el-button>
              <el-button no="CopyTheMbl" :disabled="!isEditing" type="primary" style="white-space: nowrap;flex-shrink: 0;" @click="pm.copyMblCargoDoc()"> {{ $t('SeaExport.CopyTheMbl') }} </el-button>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between">
            <div style="margin-right: 10px;">
              <el-form-item label="Shipper" class="custom">
                <div style="display: flex;width:500px;">

                  <cargo-input
                    v-model="form.shipperCode"
                    :disabled="!isEditing"
                    no="shipperCode"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                  />
                  <cargo-company-select
                    no="shipperId"
                    :disabled="!isEditing"
                    :method-params="{shipper:true,active:true}"
                    :default-value="form.shipperId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    @change="data => {shipperChangeHandler(data)}"
                  />
                  <el-button no="onClear1" type="primary" style="margin-left: 5px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item class="label-none custom ">
                <cargo-input
                  v-model="form.shipperLine1"
                  :disabled="!isEditing"
                  no="shipperLine1"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine1','shipperLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.shipperLine2"
                  no="shipperLine2"
                  :disabled="!isEditing"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine2','shipperLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.shipperLine3"
                  no="shipperLine3"
                  :disabled="!isEditing"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine3','shipperLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.shipperLine4"
                  no="shipperLine4"
                  :disabled="!isEditing"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine4','shipperLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.shipperLine5"
                  no="shipperLine5"
                  :disabled="!isEditing"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine5','shipperLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.shipperLine6"
                  no="shipperLine6"
                  :disabled="!isEditing"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.shipperLine7"
                  no="shipperLine7"
                  :disabled="!isEditing"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                />
              </el-form-item>
              <el-form-item label="Consignee" class="custom">
                <div style="display: flex;width:500px;">

                  <cargo-input
                    v-model="form.consigneeCode"
                    no="consigneeCode"
                    :disabled="!isEditing"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                  />
                  <cargo-company-select
                    no="consigneeId"
                    :disabled="!isEditing"
                    :method-params="{consignee:true,active:true}"
                    :default-value="form.consigneeId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    @change="data => {consigneeChangeHandler(data)}"
                  />
                  <el-button no="onClear2" type="primary" style="margin-left: 5px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine1"
                  :disabled="!isEditing"
                  no="consigneeLine1"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine1','consigneeLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine2"
                  :disabled="!isEditing"
                  no="consigneeLine2"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine2','consigneeLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine3"
                  :disabled="!isEditing"
                  no="consigneeLine3"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine3','consigneeLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine4"
                  :disabled="!isEditing"
                  no="consigneeLine4"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine4','consigneeLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine5"
                  :disabled="!isEditing"
                  no="consigneeLine5"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine5','consigneeLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine6"
                  :disabled="!isEditing"
                  no="consigneeLine6"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.consigneeLine7"
                  :disabled="!isEditing"
                  no="consigneeLine7"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                />
              </el-form-item>
              <div style="display: flex;flex-direction: column">
                <span>Airport of Departure</span>

                <cargo-input
                  v-model="form.airportOfDeparture"
                  :disabled="!isEditing"
                  no="airportOfDeparture"
                  :auto-uppercase="isUppercase"
                />
              </div>
            </div>
            <div>
              <el-form-item label="Notify" class="custom">
                <div style="display: flex;width:520px;">

                  <cargo-input
                    v-model="form.notifyCode"
                    :disabled="!isEditing"
                    no="notifyCode"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                  />
                  <cargo-company-select
                    no="notifyId"
                    :disabled="!isEditing"
                    :method-params="{notify:true,active:true}"
                    :default-value="form.notifyId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    @change="data => {notifyChangeHandler(data)}"
                  />
                  <el-button no="onClear3" type="primary" style="margin-left: 5px" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine1"
                  :disabled="!isEditing"
                  no="notifyLine1"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine1','notifyLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine2"
                  :disabled="!isEditing"
                  no="notifyLine2"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine2','notifyLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine3"
                  :disabled="!isEditing"
                  no="notifyLine3"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine3','notifyLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine4"
                  :disabled="!isEditing"
                  no="notifyLine4"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine4','notifyLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine5"
                  :disabled="!isEditing"
                  no="notifyLine5"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine5','notifyLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine6"
                  :disabled="!isEditing"
                  no="notifyLine6"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  v-model="form.notifyLine7"
                  :disabled="!isEditing"
                  no="notifyLine7"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                />
              </el-form-item>
              <div style="display: flex;flex-direction: column">
                <span>Issued By</span>
                <cargo-rich-textarea
                  v-model="form.issuedBy"
                  :disabled="!isEditing"
                  no="issuedBy"
                  :text-chars="0"
                  :auto-uppercase="true"
                  :warning-count="-1"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog('Issued By',form.issuedBy,val=>{form.issuedBy=val})"
                />
              </div>
              <div style="display: flex;flex-direction: column">
                <span>Accounting Information</span>
                <cargo-rich-textarea
                  v-model="form.accountingInfo"
                  :disabled="!isEditing"
                  no="accountingInfo"
                  :text-chars="0"
                  :auto-uppercase="true"
                  :warning-count="-1"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog('Accounting Information',form.accountingInfo,val=>{form.accountingInfo=val})"
                />
              </div>
              <div style="display: flex;justify-content: space-between;margin-top: 39px;">
                <div style="display: flex;margin-right: 2px;">
                  <span>Freight Term</span>

                  <cargo-input
                    v-model="freightTerm"
                    no="freightTerm"
                    :auto-uppercase="isUppercase"
                    style="width: 190px"
                    :disabled="true"
                  />
                </div>
                <div style="display: flex;">
                  <span>{{ $t("SeaExport.PiecesType2") }}</span>
                  <el-input-number
                    :value="form.insideQuantity || undefined"
                    no="insideQuantity"
                    controls-position="right"
                    :controls="false"
                    :min="0"
                    :max="999999999999"
                    :disabled="!isEditing"
                    style="width:130px;margin-right:5px"
                    @input="val=>{form.insideQuantity=val}"
                  />

                  <cargo-input
                    v-model="form.insidePacking"
                    :disabled="!isEditing"
                    no="insidePacking"
                    :auto-uppercase="isUppercase"
                    style="width: 115px"
                  />
                </div>
              </div>
            </div>

          </div>
          <div style="display: flex;justify-content: space-between">
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>

              <cargo-input
                v-model="form.podTo"
                :disabled="!isEditing"
                no="podTo"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>By First Carrier</span>

              <cargo-input
                v-model="form.carrierBy"
                :disabled="!isEditing"
                no="carrierBy"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>

              <cargo-input
                v-model="form.podTo1"
                :disabled="!isEditing"
                no="podTo1"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>By</span>

              <cargo-input
                v-model="form.carrierBy1"
                :disabled="!isEditing"
                no="carrierBy1"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>

              <cargo-input
                v-model="form.podTo2"
                :disabled="!isEditing"
                no="podTo2"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>By</span>

              <cargo-input
                v-model="form.carrierBy2"
                :disabled="!isEditing"
                no="carrierBy2"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>Currency</span>
              <!--              <el-select v-model="form.currency" no="currency">-->
              <!--                <el-option-->
              <!--                  v-for="item in AirExportConstants.CURRENCY"-->
              <!--                  :key="item"-->
              <!--                  :value="item"-->
              <!--                />-->
              <!--              </el-select>-->
              <cargo-advance-select
                no="currency"
                :select-type="selectTypeNames.basic_data_Currency"
                :disabled="!isEditing"
                filterable
                :clearable="false"
                :static-options="currencyList"
                :default-value="form.currency"
                @parentCallBack="p=>{form.currency=p.value}"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>WT/VAL</span>
              <el-select v-model="form.wtVal" :disabled="!isEditing" no="wtVal" @change="cpChangeHandler('wtVal')">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>Other</span>
              <el-select v-model="form.other" :disabled="!isEditing" no="other" @change="cpChangeHandler('other')">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>D.V.Carrier</span>

              <cargo-input
                v-model="form.carriageDv"
                :disabled="!isEditing"
                no="carriageDv"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>D.V. for Customs</span>

              <cargo-input
                v-model="form.dvForCustoms"
                :disabled="!isEditing"
                no="dvForCustoms"
                :auto-uppercase="isUppercase"
              />
            </div>
          </div>
          <div style="width: 65%; display: flex;justify-content: flex-start">
            <div style="display: flex;flex-direction: column; flex:1; margin-right: 10px;">
              <span>Airport of Destination</span>
              <cargo-input
                v-model="form.airportOfDestination"
                :disabled="!isEditing"
                no="airportOfDestination"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>Flight/Date</span>
              <el-date-picker
                v-model="job.etd"
                :disabled="true"
                no="etd"
                clearable
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>Amount of insurance</span>

              <cargo-input
                v-model="form.insuredAmount"
                :disabled="!isEditing"
                no="insuredAmount"
                :auto-uppercase="isUppercase"
              />
            </div>
          </div>
          <div>
            <div style="display: flex;flex-direction: column">
              <span>Handling Info</span>
              <cargo-rich-textarea
                v-model="form.handingInfo"
                :disabled="!isEditing"
                no="handingInfo"
                :text-chars="0"
                :auto-uppercase="true"
                :warning-count="-1"
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog('Handling Information',form.handingInfo,val=>{form.handingInfo=val})"
              />
            </div>
          </div>
          <hawb-part1 ref="part1" :cargo-doc="form" :job="job" :action="action" :is-uppercase-by-config="isUppercaseByConfig" style="width: 100%;" />

        </el-form>

      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="!isEditing"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEditing" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="billAddressDialog.job" :params="billAddressDialog.params" @callback="codeSearchCallback" />
    <!-- 反恐地址格式化弹窗 -->
    <address-format-dialog
      :visible.sync="addressFormatDialog.visible"
      :job="addressFormatDialog.job"
      :params="addressFormatDialog.params"
    />
    <!--单号抄录-->
    <copy-from-other-bill-dialog
      :doc-type="copyFromOtherBillDialog.docType"
      :visible.sync="copyFromOtherBillDialog.visible"
      @selected="transcribeEnterHandler"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import follow from '@/assets/follow.png'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import HawbPart1 from '@/views/cargo/v0/AirImport/components/booking/tabs/HAWBPart1'
import { CommonHAWBPM } from '@/views/cargo/v0/AirImport/components/booking/tabs/CommonHAWBPM'
import addressFormatDialog from '@/views/cargo/v0/AirImport/components/booking/aeAddressFormatDialog'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import copyFromOtherBillDialog from '@/components/Cargo/Job/copyFromOtherBillDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { getToken } from '@/utils/auth'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'CommonHawb',
  components: {
    billAddressDialog,
    jobNoTranscribeDialog,
    cargoAdvanceSelect,
    cargoInput,
    cargoCompanySelect,
    HawbPart1,
    addressFormatDialog,
    cargoRichTextarea,
    copyFromOtherBillDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      img: { follow },
      pm: new CommonHAWBPM(this),
      AirExportConstants,
      selectTypeNames: TYPE_NAMES,
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        job: {},
        params: { cargoDocs: [] }
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      billAddressDialog: {
        visible: false,
        params: null,
        job: null
      },
      maxChars: 34,
      warningCount: 0,
      isUppercase: true,
      NumberUtils,
      CargoDocUtil,
      copyFromOtherBillDialog: {
        visible: false,
        docType: ''
      },
      freightTerm: '',
      currencyList: [],
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    isEditing() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !(this.form && this.form.state > 2)
    }
  },
  watch: {

  },
  async created() {
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify(this.context.config)
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    await this.createCurrency()
  },
  methods: {
    async createCurrency() {
      const currencyList = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
      this.currencyList = []
      for (const c of currencyList) {
        const currency = { ...c }
        if (currency.code === 'RMB') {
          currency.code = 'CNY'
        }
        this.currencyList.push(currency)
      }
    },
    fillView() {
      this.createCurrency()
      this.pm.fillView()
    },
    showAddressFormatDialog() {
      this.addressFormatDialog.job = this.job
      this.addressFormatDialog.params = { cargoDocs: [this.form] }
      this.addressFormatDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    copyFromOtherBillHandler() {
      this.copyFromOtherBillDialog.docType = this.form.docType
      this.copyFromOtherBillDialog.visible = true
    },
    popUpAddressWindow() {
      this.billAddressDialog.visible = true
      this.billAddressDialog.params = { ...this.form }
      this.billAddressDialog.job = this.job
      this.billAddressDialog.visible = true
    },

    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify)
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify)
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Notify'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify)
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      return result.trimRight() + (this.form['shipperLine7'] || '')
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      return result.trimRight() + (this.form['consigneeLine7'] || '')
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      return result.trimRight() + (this.form['notifyLine7'] || '')
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.formatObj = formatObject ? { ...this.advanceTextDialog.formatObj, ...formatObject } : this.advanceTextDialog.formatObj
      this.advanceTextDialog.visible = true
    },
    executeTask() {
      this.pm.executeTask()
    },
    async showMBLDetailBtnClickHandler() {
      await cache.load(cacheName.CONFIG)
      const consoleURL = cache.config.get('AIMawbNoDetailUrl')
      // 对按钮点击进行埋点
      // LogStores.sendFunctionClickLogStoresByLabel('CargoWare-空运操作-分单信息页签-MBL详情')
      if (consoleURL) {
        const el = document.createElement('a')
        document.body.appendChild(el)
        el.href = consoleURL + '?MAWB=' + AirExportUtils.mawbNoDispalyFormat(this.job.mbl) + '&sessionId=' + getToken()
        el.target = '_blank'
        el.click()
        document.body.removeChild(el)
      } else {
        this.$message.warning(this.$t('queryJob.PleaseMaintainTheJumpAddress'))
      }
    },
    cpChangeHandler(type = '') {
      const from = this.form
      switch (type) {
        case 'wtVal' :
          this.$refs.part1.wtValChanged(from.wtVal)
          // CARGO-7981 币种无效
          if (from.wtVal === AirExportConstants.CC) {
            this.form.currency = 'USD'
          } else if (from.wtVal === AirExportConstants.PP) {
            this.form.currency = 'CNY'
          }
          break
        case 'other' :
          this.$refs.part1.otherChanged(from.other)
          break

        default : break
      }
    },
    transcribeEnterHandler(cargoDoc) {
      this.pm.transcribeEnterHandler(cargoDoc)
    },
    cWeightChangeHandler() {
      if (this.$refs.part1) {
        this.$refs.part1.cWeightChangeHandler()
      }
    },
    async fillModel() {
      if (this.$refs.part1) {
        await this.$refs.part1.fillModel()
      }
    },
    // 发货人选择
    async shipperChangeHandler(data) {
      await AirCargoDocUtil.shipperChangeFunc(this.form, data)
    },
    // 收货人选择
    async consigneeChangeHandler(data) {
      await AirCargoDocUtil.consigneeChangeFunc(this.form, data)
    },
    // 通知人选择
    async notifyChangeHandler(data) {
      await AirCargoDocUtil.notifyChangeFunc(this.form, data)
    }
  }
}
</script>

<style lang="scss">
  #app #tab-commonHawb {
    .el-form-item__content {
      width: 255px !important;
    }
    .hblNbr2 {
      .el-form-item__content {
        margin-left:-10px !important;
      }
    }
    .label-none {
      .el-form-item__content {
        width: 490px !important;
      }
    }
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #8cc8ff;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }
  }
</style>
